import * as Cookies from "js-cookie";

export const removeAllCookies = () => {
    Object.keys(Cookies.get()).forEach(function(cookie) {       
      if(cookie !== 'language')
        Cookies.remove(cookie);
    });    
};
